/**
 * ファイルをローカルにダウンロードする
 * クロスオリジンのURLにも対応（Firebase Storage等）
 */
export async function downloadFile(url: string, filename?: string): Promise<void> {
  const response = await fetch(url);
  const blob = await response.blob();
  const objectUrl = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename || getFilenameFromUrl(url);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  window.URL.revokeObjectURL(objectUrl);
}

function getFilenameFromUrl(url: string): string {
  if (url.includes('.mp4')) return 'certificate.mp4';
  if (url.includes('.png')) return 'certificate.png';
  return 'certificate';
}
